import React from 'react'
import AreaInput from '../AreaInput'
import Button from '../Button'
import AnimateIn from '../AnimateIn'

const LeadApartments = ({ data, isAnimated }) => {
  const paddingUnit = data.paddingUnit ? data.paddingUnit : 'px'
  const paddingTop =
    data.paddingTop !== null ? data.paddingTop + paddingUnit : null
  const paddingBottom =
    data.paddingBottom !== null ? data.paddingBottom + paddingUnit : null

  return (
    <AnimateIn disabled={!isAnimated} distance={0} opacityDuration={1000}>
      <div className="container" style={{ paddingTop, paddingBottom }}>
        <div className="flex flex-col items-center px-4 py-16 text-center bg-blueLight-100 border-t-[3px] border-blueLight-500">
          {data.title ? (
            <h3 className="text-blue-500 h4 md:h3">{data.title}</h3>
          ) : null}
          <AreaInput
            className="flex flex-col w-full max-w-lg mt-3 space-y-4 md:max-w-xl md:space-y-0 md:space-x-4 md:flex-row"
            buttonLabel={data.submitText}
            inputPlaceholder={data.inputPlaceholder}
            buttonClassName="flex-shrink-0"
          />
          {data.relatedLinkTitle ? (
            <h5 className="mt-5 text-lg text-blue-500">
              {data.relatedLinkTitle}
            </h5>
          ) : null}
          {data?.relatedLinks?.length > 0 ? (
            <div className="flex flex-col items-center justify-center mt-3 space-y-3 lg:space-y-0 lg:space-x-6 lg:flex-row">
              {data.relatedLinks.map((item) => (
                <Button
                  key={`${item.buttonLabel}-${item.buttonLink}`}
                  style={{ fontSize: '17px' }}
                  {...item}
                />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </AnimateIn>
  )
}

export default LeadApartments
